import React from 'react';
import { motion } from 'framer-motion';
import { PROBLEM_CARDS } from './offerData';

const OfferProblem: React.FC = () => (
  <section className="py-16 bg-[#2F3136]">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.h2
        className="text-balance text-2xl md:text-3xl font-bold text-white text-center mb-10"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
      >
        Vos clients vous cherchent sur Google.{' '}
        <span className="text-[#5865F2]">Est-ce qu'ils vous trouvent ?</span>
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {PROBLEM_CARDS.map(({ title, description, icon: Icon }, index) => (
          <motion.div
            key={title}
            className="rounded-xl border border-white/10 bg-white/5 p-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: index * 0.08, ease: 'easeOut' }}
          >
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-[#5865F2]/20 border border-[#5865F2]/35 text-[#9BA8FF]">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="text-white font-semibold mb-1.5">{title}</h3>
            <p className="text-gray-300 text-sm leading-relaxed">{description}</p>
          </motion.div>
        ))}
      </div>

      <p className="mt-8 text-center text-gray-200 text-base md:text-lg">
        La solution : un site internet pro, <span className="text-white font-semibold">créé, mis en ligne et mis à jour pour vous</span>, qui vous rend visible sur Google.
      </p>
    </div>
  </section>
);

export default OfferProblem;
